// Typekit
import 'vendor/typkit';

// Add global configuration objects here...
document.documentElement.classList.remove('no-js');

window.haz = {
  globalTimeout: 250,
  ads: {
    zone: 'homepage',
    disabledSlots: [],
    desktop: {
      slots: [
        {
          stroeer: true,
          adSlotName: 'banner',
          id: 'oms_gpt_superbanner',
          removeSizes: [[800, 250], [970, 250]],
        },
        {
          stroeer: true,
          adSlotName: 'sky',
          id: 'oms_gpt_skyscraper',
        },
        {
          stroeer: true,
          adSlotName: 'billboard',
          id: 'oms_gpt_billboard',
        },
        {
          stroeer: true,
          adSlotName: 'out-of-page',
          id: 'oms_gpt_outofpage',
        },
        {
          stroeer: true,
          adSlotName: 'rectangle',
          id: 'oms_gpt_standard',
          removeSizes: [300, 600],
        },
        {
          stroeer: true,
          adSlotName: 'rectangle2',
          id: 'oms_gpt_standard2',
        },
      ],
      targeting: {
        bundesland: ['NI'],
      },
    },
    tablet: {
      maxWidth: 1024,
      slots: [
        {
          stroeer: true,
          adSlotName: 'topmobile',
          id: 'oms_gpt_standard',
        },
        {
          stroeer: true,
          adSlotName: 'topmobile2',
          id: 'oms_gpt_billboard',
        },
      ],
      targeting: {
        bundesland: ['NI'],
      },
    },
    mobile: {
      maxWidth: 640,
      slots: [
        {
          stroeer: true,
          adSlotName: 'topmobile',
          id: 'oms_gpt_standard',
        },
        {
          stroeer: true,
          adSlotName: 'topmobile2',
          id: 'oms_gpt_topmobile2',
        },
        {
          stroeer: true,
          adSlotName: 'topmobile2',
          id: 'oms_gpt_billboard',
        },
      ],
      targeting: {
        bundesland: ['NI'],
      },
    },
  },
};
